import React from 'react';
import SocialList from 'components/SocialList';
import './footer.scss';

function Footer() {
  return (
    <footer className='footer'>
      <div className='copyright'>© Copyright 2014-2026&nbsp; ❤️  Effy Yin</div>
      <SocialList />
    </footer>
  );
}

export default Footer;
